import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../infrastructure/redux/store';
import { formatar_sigla_disciplina } from '../../../../utils/formater/disciplina.formater';
import { formatar_sigla_professor } from '../../../../utils/formater/professor.formater';
import { IAlocacao } from '../../../../utils/generators/grade_alocaoes.generator';
import { Container, Coluna, Checkbox } from './styles';

interface Props {
  alocacao: IAlocacao;
  onSelect: (data: IAlocacao) => void;
}

const LinhaAlocacao: React.FC<Props> = (props) => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const tipo_dia = (feriado?: boolean, fim_semana?: boolean) => {
    if (feriado) return 'feriado';
    else if (fim_semana) return 'fim-semana';
    else return 'dia';
  };

  const cor_alocacao = [
    undefined,
    theme.colors.color2,
    theme.colors.color3,
    theme.colors.color4,
    theme.colors.color5,
    theme.colors.color6,
  ];

  const ref = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    const { current: checkbox } = ref;

    if (!checkbox) return;

    /** Desmarcar se for uma alocação */
    if (props.alocacao.professor) {
      checkbox.checked = false;
    }
  }, [props.alocacao.professor]);

  return (
    <Container
      className={tipo_dia(Boolean(props.alocacao.dsc_feriado), props.alocacao.fim_semana)}
      cor_professor={cor_alocacao[(props.alocacao.id_cor || 1) - 1]}
      alocacao_pendente={props.alocacao.planejamento}
    >
      <Coluna>
        <Checkbox onChange={() => props.onSelect(props.alocacao)} ref={ref} />
      </Coluna>
      <Coluna>{props.alocacao.dia_numero}</Coluna>
      <Coluna>{props.alocacao.dia_semana}</Coluna>
      <Coluna>{formatar_sigla_disciplina(props.alocacao.disciplina)}</Coluna>
      <Coluna>{formatar_sigla_professor(props.alocacao.professor)}</Coluna>
    </Container>
  );
};

export { LinhaAlocacao };
